/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import UploadProgress from 'shared/ui/components/uploader/UploadProgress.vue';

// Constants
const WorkerScope = window.SharedWorker ? MessagePort : Worker;
const WorkerType = window.SharedWorker ? SharedWorker : Worker;

// Mixins
import uploader from './uploader';

const __vue_script__ = {
    name: 'UploadManager',

    components: { UploadProgress },

    mixins: [uploader],

    props: {
        workerScope: {
            type: WorkerScope,
            default: () => null
        },

        worker: {
            type: WorkerType,
            default: () => null
        }
    },

    computed: {
        /** @returns {string} */
        statusTitle() {
            const filesCount = this.totalUploadsCount;
            let title;

            if (!this.started) {
                title = this.$i18n.t('media.uploads.starting_upload');
            } else {
                title = this.$i18n.tc('media.uploads.items_uploaded', filesCount, [this.uploadedFiles, filesCount]);
            }
            return title.toString();
        }
    },

    watch: {
        worker: {
            immediate: true,
            handler() {
                if (!this.workerScope) return;
                console.debug('[UploadManager] Binding handler');
                this.workerScope.addEventListener('message', this.handleWorkerMessage);
            }
        }
    },

    beforeDestroy() {
        if (this.workerScope) {
            this.workerScope.removeEventListener('message', this.handleWorkerMessage);
        }
    },

    methods: {
        /**
         * Closes the upload manager UI (does not interrupt any upload)
         */
        close() {
            if (this.workerScope) {
                const event_id = this.event.id || this.event._id;
                this.workerScope.postMessage({ command: 'clear', event_id });
            }
            this.reset();
            this.visible = false;
        },

        /**
         * Shows and hides the uploading list
         */
        toggleCollapsed() {
            this.collapsed = !this.collapsed;
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "upload-manager",
      class: { active: _vm.visible, collapsed: _vm.collapsed },
    },
    [
      _c("header", [
        _c("div", { staticClass: "title" }, [
          !_vm.activeUploads
            ? _c("a", {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    return _vm.close()
                  },
                },
              })
            : _vm._e(),
          _c("a", {
            staticClass: "collapse",
            on: { click: _vm.toggleCollapsed },
          }),
          _vm._v(_vm._s(_vm.statusTitle)),
        ]),
      ]),
      _c("section", { staticClass: "uploads" }, [
        _vm.activeUploads >= 1
          ? _c("div", { staticClass: "batch-actions" }, [
              _c(
                "a",
                {
                  staticClass: "has-action",
                  on: {
                    click: function ($event) {
                      return _vm.abort()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("media.uploads.cancel_all")))]
              ),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "items" },
          _vm._l(_vm.uploads, function (upload) {
            return _c("upload-progress", {
              key: upload.key || upload.id,
              attrs: { upload: upload, "worker-scope": _vm.workerScope },
              on: {
                progress: function ($event) {
                  return _vm.setStarted()
                },
                started: function ($event) {
                  return _vm.increaseCounters()
                },
                canceled: function ($event) {
                  return _vm.decreaseCounters()
                },
                completed: function (result) {
                  return _vm.decreaseCounters(result)
                },
                error: function ($event) {
                  return _vm.decreaseAndShowError()
                },
                abort: function ($event) {
                  return _vm.abort(upload)
                },
              },
            })
          }),
          1
        ),
      ]),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/uploader/UploadManager.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__